module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNyIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDE3IDMyIiB4PSIyNDAiPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0xNS42OTUgMTcuMzcxbC43NjItNS42MzhoLTUuNjM4VjguMDc2YzAtMS42NzYuNDU3LTIuNzQzIDIuODk1LTIuNzQzaDMuMDQ4Vi4xNTJjLS42MSAwLTIuNDM4LS4xNTItNC41NzEtLjE1Mi00LjI2NyAwLTcuMzE0IDIuNTktNy4zMTQgNy40Njd2NC4yNjdILjAwMXY1LjYzOGg0Ljg3NnYxNC42MjloNS45NDNWMTcuMzcyaDQuODc2eiIvPjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/assets/fb.svg
// module id = 7140
// module chunks = 114276838955818